import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSelectValueContainer from './HseSelectValueContainer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSelectValueContainer;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({ref:"root",staticClass:"hse-Select__valueContainer",class:( _obj = {
    'hse-Select__valueContainer_focused': _vm.focused,
    'hse-Select__valueContainer_disabled': _vm.disabled,
    'hse-Select__valueContainer_selected': _vm.selected
  }, _obj[("hse-Select__valueContainer_size_" + _vm.size)] = _vm.size, _obj )},'div',_vm.$attrs,false),_vm.$listeners),[(_vm.leftIcon)?_c('HseIcon',{staticClass:"hse-Select__valueContainerLeftIcon",attrs:{"color":_vm.iconColor,"size":"medium"}}):_vm._e(),_vm._v(" "),(_vm.showTags)?[_c('div',{ref:"multipleValues",staticClass:"hse-Select__multipleValues"},_vm._l((_vm.slicedOptions),function(option,iOption){return _c('HseSelectTag',{key:iOption,attrs:{"focused":_vm.focusedTagI === iOption}},[_vm._v("\n        "+_vm._s(option.label || option.value)+"\n      ")])}),1),_vm._v(" "),(_vm.isNotAllTagsVisible)?_c('div',{staticClass:"hse-Select__multipleValuesEtc"},[_vm._v("\n      ...\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hse-Select__valuesCounter",class:{
        'hse-Select__valuesCounter_disabled': _vm.disabled
      }},[_vm._v("\n      "+_vm._s(_vm.selectedOptions.length)+"\n    ")])]:(_vm.showInputInValueField)?_vm._t("searchInput"):(_vm.showSelectedValueInField)?_c('div',{staticClass:"hse-Select__value",class:_vm.classes.value},[_vm._v("\n    "+_vm._s(_vm.singleValueLabel)+"\n  ")]):(_vm.showPlaceholderInField)?_c('div',{staticClass:"hse-Select__valuePlaceholder",class:_vm.classes.valuePlaceholder},[_vm._v("\n    "+_vm._s(_vm.placeholder)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.showClearIcon)?_c('HseClickableIcon',{staticClass:"hse-Select__clearIcon",class:_vm.classes.clearIcon,attrs:{"disabled":_vm.disabled,"focused":_vm.clearButtonFocused,"icon":_vm.IconActionDelete,"tabindex":_vm.disabled ? -1 : 0,"size":"small"},on:{"click":function($event){return _vm.$emit('click:clear', $event)},"focus":function($event){return _vm.$emit('focus:clear', $event)},"blur":function($event){return _vm.$emit('blur:clear', $event)}}}):_vm._e(),_vm._v(" "),_c('HseIcon',{staticClass:"hse-Select__valueContainerIcon",class:{
      'hse-Select__valueContainerIcon_opened': _vm.isOpen
    },attrs:{"icon":_vm.IconActionArrowDropdownBottom,"size":"medium"}})],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
